import * as React from 'react';
import { cn } from '../lib/utils';

function Carousel({ className, children, ...props }: React.ComponentProps<'ul'>) {
	return (
		// `pan-y` is listed alongside `pan-x` so a vertical swipe that starts on a slide still scrolls
		// the page instead of being swallowed by the carousel (a plain `pan-x` traps the gesture).
		<ul className={cn('carousel flex w-full gap-4 px-6 [touch-action:pan-x_pan-y_pinch-zoom]', className)} {...props}>
			{children}
		</ul>
	);
}

function CarouselItem({ className, ...props }: React.ComponentProps<'li'>) {
	return <li className={cn('shrink-0', className)} {...props} />;
}

export { Carousel, CarouselItem };
